// extracted by mini-css-extract-plugin
export default {"AntSelect__label":"AntSelect_AntSelect__label__no4-w"};